import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SosCoreModule } from '@serviceos-ng/core';
import { ScriptLoaderModule } from 'ngx-script-loader';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SosCoreModule,
        ScriptLoaderModule,
    ],
})
export class ClientSupportModule {}
